import React, { useEffect, useState } from 'react';
import Swal from 'sweetalert2';
import { emailRegex, FormState, phoneRegex } from '@opu/utils';
import AxiosInstance from '../../../helpers/AxiosInstance';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

const useForm = () => {
  const history = useHistory();
  const { t, i18n } = useTranslation();
  const [establishments, setEstablishments] = useState([]);
  const [loading, setLoading] = useState(false);

  const getEstablishments = () => {
    setLoading(true);
    // Fetch all establishments so Autocomplete is not limited to the first page
    AxiosInstance.get('/establishment', { params: { limit: 500, page: 0 } })
      .then((res) => {
        setEstablishments(res.data.items);
      })
      .catch((error) => {
        Swal.fire(t('establishment.ERROR_GET_ESTABLISHMENT'), '', 'error');
      })
      .finally(() => {
        setLoading(false);
      });
  };
  const createEstablishmentUser = () => {
    setLoading(true);
    AxiosInstance.post('/establishment-user', {
      firstName: formState.inputValues.firstName,
      lastName: formState.inputValues.lastName,
      gender: formState.inputValues.gender,
      email: formState.inputValues.email,
      phone: formState.inputValues.phone,
      establishmentId: formState.inputValues.establishmentId,
    })
      .then((res) => {
        Swal.fire(t('establishment-user.SUCCESS_CREATE_ESTABLISHMENT_USER'), '', 'success');
        resetFormState();
      })
      .catch((error) => {
        const messages = error?.data?.message;
        if (error.status === 400 && messages) {
          handleErrorsServer(messages);
          const text = Array.isArray(messages) ? messages[0] : messages;
          Swal.fire(t(text) || t('establishment-user.ERROR_CREATE_ESTABLISHMENT_USER'), '', 'error');
        } else {
          Swal.fire(t('establishment-user.ERROR_CREATE_ESTABLISHMENT_USER'), '', 'error');
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    getEstablishments();
  }, []);

  const back = () => {
    history.goBack();
  };

  const inputValues = {
    firstName: { value: '', validate: { required: true } },
    lastName: { value: '', validate: { required: true } },
    email: { value: '', validate: { required: true, pattern: emailRegex } },
    phone: { value: '', validate: { required: true, pattern: phoneRegex } },
    gender: { value: '', validate: { required: true } },
    establishmentId: { value: '', validate: { required: true } },
  };

  const { formState, submitHandler, resetFormState, field, handleErrorsServer } = FormState(inputValues, createEstablishmentUser);

  return {
    submitHandler,
    resetFormState,
    field,
    establishments,
    loading,
    back,
  };
};

export default useForm;
